import { FileObject } from './File';

export interface FileTemplate {
  length: number;
  id: number;
  language: FileTemplateLanguage;
  createdDate: string;
  employee: string;
  document: FileObject;
}

export enum FileTemplateLanguage {
  UZLAT = 'UZLAT',
  UZCYR = 'UZCYR',
  RU = 'RU',
  EN = 'EN',
  TJ = 'TJ',
  TR = 'TR',
  KY = 'KY',
  English = 'English',
  UZBEK = "O'zbek",
  RUSSIAN = 'Русский',
  KIRIL = 'Кирилл',
  TAJIK = 'Тоҷикӣ',
  KYRGYZ = 'Кыргыз'
}

export enum FileTemplateType {
  CONTRACT = 'CONTRACT',
  PAYMENT = 'PAYMENT',
  CLIENT_PAYMENT = 'CLIENT_PAYMENT',
  ACT = 'ACT',
  BOOKING = 'BOOKING',
  CONTRACT_CUSTOM = 'CONTRACT_CUSTOM',
  BOOKING_PAYMENT = 'BOOKING_PAYMENT'
}
